
import{TOGGLE_GLOBAL_LOADER} from './types'
export const toggleGlobalLoader = (value) => {
    return {
      type: TOGGLE_GLOBAL_LOADER,
      value,
    };
  };